<template>
    <div :style="{ padding: '20px' }">

        
        

        <a-row class="mt-50 mb-0">
            <a-col class="mb-20" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 16 }">
                <span :style="{ fontSize: '16px', color: '#000000' }" class="mr-20 font-web mt-0 font-weight-bold">
                    <strong><a-icon class="mr-10" type="schedule" />ข้อมูลสรุปผล <i>ประจำปีงบประมาณ</i></strong>
                </span>
                <div>
                    <!-- content -->
                    <p class="f-500 font-web mt-5 mb-0 text-danger" style="font-size: 12px">
                        -> เป็นเพียงข้อมูลเบื้องต้นเท่านั้นหากต้องการทราบรายละเอียด โปรดติดต่อ HR
                        อีกครั้ง
                    </p>
                    <p class="f-500 font-web mt-0 mb-0 text-danger" style="font-size: 12px">
                        -> ระบบเริ่มคำนวณข้อมูล ตั้งแต่ 1 ตุลาคม 2565
                    </p>
                </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 8 }">
                <a-select class="mt-0 mb-10 text-center" v-model="selectedBudget" :default-value="nowYear"
                    :disabled="mainLoading" style="width: 100%;">
                    <a-select-option v-for="(option, i) in optionBudgetYear" :key="'option' + i" :value="option.value">
                        <span :style="{ fontWeight: 'bold' }" class="ml-10 mr-10 font-web font-weight-bold">
                            {{ option.text }}
                        </span>
                        <a-tag color="purple"><b>{{ option.remark }}</b></a-tag>
                    </a-select-option>
                </a-select>
            </a-col>
        </a-row>

        <div v-if="mainLoading" class="mt-20 mb-0 text-center">
            <a-progress class="mt-5 mb-5" stroke-linecap="square" :percent="percent" />
            <span style="font-weight: 600;"><a-spin /><i class="font-web"> {{ textLoading }}</i></span>
        </div>

        <a-skeleton class="mt-10 mb-30" :loading="mainLoading">

            
            <!-- Counter Widgets -->
            <a-row class="mt-30 mb-30" :gutter="24">
                <a-col :span="24" :lg="12" :xl="6" class="mb-24" v-for="(stat, index) in addWidget" :key="index">
                    <!-- Widget 1 Card -->
                    <cardQuota class="" :title="stat.toppic" :value="stat.used" :suffix="' / ' + stat.limit" prefix=""
                        icon="" status='' :index="index">
                    </cardQuota>
                    <!-- / Widget 1 Card -->
                </a-col>
            </a-row>
            <!-- / Counter Widgets -->
        </a-skeleton>

        

        <div>
            <a-row
                v-if="!((checkRoleView(['staff']) && checkRoleView(['faculty'])) || (checkRoleView(['staff']) && checkRoleView(['pc_lecturers']))) || $store.state.role.RulesUser.permissions.indexOf(`TeamDev:staff`) >= 0"
                class="mt-30 mb-30">
                <a-col class="mb-20" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 16 }">
                    <span :style="{ fontSize: '16px', color: '#000000' }" class="mr-20 font-web mt-0 font-weight-bold">
                        <strong><a-icon class="mr-10" type="file-protect" />ข้อมูลสรุปผล <i>การทำงานสาย</i></strong>
                        <br>
                        <i class="ml-5"><small class="text-muted" style="font-size: '7px'">patch interface : (ver. 0.0.10)</small></i>
                    </span>
                    <div>
                        <p class="f-500 font-web mt-5 mb-0 text-danger" style="font-size: 12px">
                            -> ข้อมูลการมาสายที่แสดง
                            เป็นเพียงข้อมูลเบื้องต้นเท่านั้นหากต้องการทราบรายละเอียด โปรดติดต่อ HR อีกครั้ง
                        </p>
                        <p v-if="selectedBudget == 2023" class="f-500 font-web mt-0 mb-0 text-danger"
                            style="font-size: 12px">
                            -> ระบบเริ่มคำนวณข้อมูล การมาทำงานสาย ตั้งแต่ 1 ตุลาคม 2565
                        </p>
                        <p class="f-500 font-web mt-10 mb-10 text-danger" style="font-size: 12px">
                            <u>การมาทำงานสาย ให้คิดรวบรวมในแต่ละเดือนและไม่ยกยอดไปรวมในเดือนถัดไป</u>
                        </p>
                        <ul>
                            <li class="f-500 font-web mt-0 mb-0 text-danger" style="font-size: 12px">
                            *** ไม่ถึง 180 นาที : ไม่ถูกหักคะแนน ***
                            </li>
                            <li class="f-500 font-web mt-0 mb-0 text-danger" style="font-size: 12px">
                                *** ตั้งแต่ 180 นาที แต่ไม่ถึง 300 นาที หักคะแนนเท่ากับขาดงานครึ่งวัน
                                ***
                            </li>
                            <li class="f-500 font-web mt-0 mb-20 text-danger" style="font-size: 12px">
                                *** มากกว่า 300 นาที ขึ้นไป หักคะแนนเท่ากับขาดงานหนึ่งวัน ***
                            </li>
                        </ul>
                    </div>
                </a-col>
                <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                    <a-card v-if="!mainLoading" :bordered="false" class="font-web widget-1">
                        <a-statistic :value="Number.parseFloat(sumAllLate)" :prefix="''" :suffix="'วัน'" :precision="1"
                            class="text-dark font-web" style="font-family: 'Sarabun', sans-serif !important;">
                            <span slot="title" style="font-family: 'Sarabun', sans-serif !important;">รวมขาดงาน</span>
                        </a-statistic>
                        <div class="icon" :style="{ backgroundColor: ![0,'0',0.0,'0.0'].includes(sumAllLate) ? '#C51605' : '#5B9A8B'}">
                            <a-icon type="history" :style="{ fontSize: '24px' }" />
                        </div>
                        <span :style="{ fontWeight: 900, fontSize: '12px' }"
                            class="text-muted font-web mt-0 mb-0">มาจาก การมาทำงานสาย&nbsp;&nbsp;&nbsp;&nbsp;{{ sumSubA }}&nbsp;&nbsp;วัน</span>
                        <br>
                        <span :style="{ fontWeight: 900, fontSize: '12px' }"
                            class="text-muted font-web mt-0 mb-0">มาจาก ไม่พบการบันทึกเวลา&nbsp;&nbsp;&nbsp;&nbsp;{{ sumSubB }}&nbsp;&nbsp;วัน</span>
                    </a-card>
                </a-col>
            </a-row>

            <a-skeleton class="mt-0 mb-20" :loading="mainLoading">

                <a-row :gutter="24" type="flex" align="stretch" class="equal-height-row">
                    <a-col v-for="(card, index) in itemProfileSummary" :key="card.text" :span="24" :lg="8" class="mb-24 equal-height-col">
                        <a-card size="small" hoverable :bordered="false" class="equal-height-card">
                            <a-card-meta class="mt-10 mb-20">
                                <a-avatar :style="{ backgroundColor: '#7149C6', verticalAlign: 'middle' }" slot="avatar"
                                    icon="calendar" shape="square" />
                                <div slot="title" class="">

                                    <span style="font-size: 18px;font-weight: 900;" class="font-web text-dark">
                                        
                                        {{ card.monthMainText }}
                                        ปี
                                        {{
                                            Number.parseInt(card.yearMain) + 543
                                        }}</span>
                                    <!-- // moment(`${card.yearMain}`).locale('th').add(543, 'year').format('YYYY') -->
                                    <p class="font-web"></p>
                                </div>
                            </a-card-meta>

                            <div
                                v-if="!((checkRoleView(['staff']) && checkRoleView(['faculty'])) || (checkRoleView(['staff']) && checkRoleView(['pc_lecturers']))) || $store.state.role.RulesUser.permissions.indexOf(`TeamDev:staff`) >= 0">
                                <div class="text-center">
                                    <meterGraph title="x" :value="card.dataOverview.sum_mount"></meterGraph>
                                </div>
                            </div>

                            <div class="mt-0 mb-20"></div>

                            <a-collapse v-model="collapseActiveKeys" :bordered="false" expand-icon-position="right" class="card-collapse font-web">
                                <a-collapse-panel
                                    v-if="!((checkRoleView(['staff']) && checkRoleView(['faculty'])) || (checkRoleView(['staff']) && checkRoleView(['pc_lecturers']))) || $store.state.role.RulesUser.permissions.indexOf(`TeamDev:staff`) >= 0"
                                    :key="'detail-' + index" class="collapse-panel-custom">
                                    <span slot="header" class="font-web collapse-header-text">
                                        <a-icon type="file-search" class="collapse-header-icon" />
                                        รายละเอียด
                                        <a-tag
                                            v-if="seriesA[index] && seriesA[index][`${card.yearMain}-${monthBudget[index].vtext}`] !== 0"
                                            class="ml-5 mr-5" :color="getSumLateMinutes(card.dataOverview) >= 180 ? '#FF6969' : '#b0b0b0'">
                                            มาสาย {{ seriesA[index][`${card.yearMain}-${monthBudget[index].vtext}`] }}
                                            ครั้ง
                                        </a-tag>
                                        <a-tag
                                            v-if="seriesB[index] && seriesB[index][`${card.yearMain}-${monthBudget[index].vtext}`] !== 0"
                                            color="#7D7C7C">
                                            ไม่พบการบันทึกเวลา {{
                                                seriesB[index][`${card.yearMain}-${monthBudget[index].vtext}`] }} ครั้ง
                                        </a-tag>
                                    </span>
                                    <div class="detail-scroll-area">
                                        <historyTimeline :detailTimeLine="card.dataOverview"></historyTimeline>
                                    </div>
                                </a-collapse-panel>
                                <a-collapse-panel :key="'request-' + index" class="collapse-panel-custom">
                                    <span slot="header" class="font-web collapse-header-text">
                                        <a-icon type="solution" class="collapse-header-icon" />
                                        รายการคำขอ
                                    </span>
                                    <!-- :requestLoading="cardrequestLoading" -->
                                    <historyRequest :requestA="requestA[index] && requestA[index][`${card.yearMain}-${card.monthMain}`]"
                                        :requestB="requestB[index] && requestB[index][`${card.yearMain}-${card.monthMain}`]"
                                        :requestC="requestC[index] && requestC[index][`${card.yearMain}-${card.monthMain}`]"
                                        :requestD="requestD[index] && requestD[index][`${card.yearMain}-${card.monthMain}`]"></historyRequest>
                                </a-collapse-panel>
                            </a-collapse>

                        </a-card>
                    </a-col>
                </a-row>

            </a-skeleton>
        </div>



    </div>
</template>

<script>
import cardQuota from './overview/cardQuota.vue'
import mainGraphAll from './overview/mainGraphAll.vue';
import historyTimeline from './overview/historyTimeline.vue';
import historyRequest from './overview/historyRequest.vue';
import meterGraph from './overview/meterGraph.vue';

const d = new Date();

const temp = {
    "sick": 0,
    "medical": 0,
    "long_term_medical": 0,
    "casual": 0,
    "vacation": 6.5,
    "maternity": 0,
    "monkhood": 0,
    "extra": 6,
    "other": 0
}

export default ({
    components: {
        cardQuota,
        mainGraphAll,
        meterGraph,
        historyTimeline,
        historyRequest,
    },
    data() {
        return {
            expandIconPosition: 'left',
            activeKey: [],
            // Loading
            textLoading: '',
            percent: 0,
            mainLoading: false,
            // set ข้อมูลปฏิทินปีงบ 
            nowYear: d.getFullYear(),
            nowDate: this.moment()._d,
            selectedBudget: '',
            optionBudgetYear: [],
            monthBudget: [
                { value: 10, vtext: '10', text: 'ต.ค.' },
                { value: 11, vtext: '11', text: 'พ.ย.' },
                { value: 12, vtext: '12', text: 'ธ.ค.' },
                { value: 1, vtext: '01', text: 'ม.ค.' },
                { value: 2, vtext: '02', text: 'ก.พ.' },
                { value: 3, vtext: '03', text: 'มี.ค.' },
                { value: 4, vtext: '04', text: 'เม.ย.' },
                { value: 5, vtext: '05', text: 'พ.ค.' },
                { value: 6, vtext: '06', text: 'มิ.ย.' },
                { value: 7, vtext: '07', text: 'ก.ค.' },
                { value: 8, vtext: '08', text: 'ส.ค.' },
                { value: 9, vtext: '09', text: 'ก.ย.' },
            ],
            // ที่เก็บ ของ
            itemProfileSummary: [],
            // query Calendar
            queryStart: '',
            queryEnd: '',
            // ตั้งค่ากราฟ
            itemLabel: [],
            seriesSum: [],
            seriesA: [],
            seriesB: [],
            seriesC: [],
            // ค่า request
            requestLoading: false,
            requestA: [],
            requestB: [],
            requestC: [],
            requestD: [],
            // 
            addWidget: [],
            // cal
            sumAllLate: 0,
            sumSubA: 0,
            sumSubB: 0,
            // collapse keys
            collapseActiveKeys: []
        }
    },
    computed: {
        changeData() {
            const { selectedBudget } = this;
            return {
                selectedBudget
            };
        },
    },
    mounted() {
        this.setOptionYearBudget()
    },
    watch: {
        changeData: {
            handler: function (val) {
                if (!['', null].includes(val.selectedBudget)) {
                    this.getDataAbsentInBudget()
                }
            },
            deep: true,
        },
        activeKey(key) {
            this.getDataRequest(key);
        },
    },
    methods: {
        checkRoleView(arrVal) {
            let count = 0;
            for (let index = 0; index < arrVal.length; index++) {
                if (this.$store.state.role.RulesUser.length != 0) {
                    if (this.$store.state.role.RulesUser.roles.includes(arrVal[index])) {
                        count++;
                    }
                }
            }
            return count > 0 ? true : false;
        },
        notiErrorApi(url, data) {
            this.$notification.open({
                style: {
                    backgroundColor: "#ff1919",
                    color: "#ffffff",
                },
                message: function (h) {
                    return h("div", [
                        h("strong", { class: "font-web" }, `Error ${data}`),
                    ]);
                },
                description: `พบปัญหาการเรียกข้อมูล : ${url}`,
            });
        },
        setOptionYearBudget() {

            this.queryStart = `${this.moment(`${Number.parseInt(this.nowYear) - 1}-10-01`).format("YYYY-MM-DD")}`
            this.queryEnd = `${this.moment(`${this.nowYear}-09-30`).format("YYYY-MM-DD")}`

            // เริ่ม 2565 เป็นต้นไป (ใช้ปี พ.ศ. เป็น value)
            const currentBEYear = Number.parseInt(this.moment().format('YYYY')) + 543
            const startBEYear = 2565
            for (let beYear = startBEYear; beYear <= currentBEYear + 1; beYear++) {
                this.optionBudgetYear.push({
                    'value': beYear,
                    'text': `${beYear}`,
                    'remark': `[  ต.ค. ${beYear - 1} - ก.ย. ${beYear}  ]`,
                })
            }

            // set default เป็นปี พ.ศ. ปัจจุบัน
            this.selectedBudget = currentBEYear

        },
        getDayInFirst(month, year) {
            return new Date(year, month, 1).getDate().toString().length == 1
                ? "0" + new Date(year, month, 1).getDate()
                : new Date(year, month, 1).getDate();
        },
        getDayInLast(month, year) {
            return new Date(year, month, 0).getDate().toString().length == 1
                ? "0" + new Date(year, month, 0).getDate()
                : new Date(year, month, 0).getDate();
        },
        async getLeaveQuota(FiscalYear) {
            this.addWidget = []
            let vacationQuota = `/hri/vacation_quota/casual/?year=${FiscalYear}`
            let quotaAll = `/hri/leave_of_absence/summary_absence/?year=${FiscalYear}`
            let quotaCuscal = `/hri/vacation_quota/?year=${FiscalYear}`

            const fetchA = await this.$http.get(vacationQuota);
            const fetchB = await this.$http.get(quotaAll);
            const fetchD = await this.$http.get(quotaCuscal);

            Promise.all([fetchA, fetchB, fetchD])
                .then((response) => {
                    return Promise.all(response.map((r) => {
                        //  r.data
                        if (r.status == 200) {
                            return r.data
                        } else {
                            return ({
                                "sick": 0,
                                "medical": 0,
                                "long_term_medical": 0,
                                "casual": 0,
                                "vacation": 0,
                                "maternity": 0,
                                "monkhood": 0,
                                "extra": 6,
                                "other": 0
                            })
                        }
                    }));
                })
                .then(([listA, listB, listD]) => {
                    this.addWidget = [
                        {
                            index: 0,
                            toppic: "Vacation leave",
                            desc: "",
                            used: `${listB.vacation}`,
                            limit: listD.length !== 0 ? listD[0].quota : 0,
                        },
                        {
                            index: 1,
                            toppic: "Sick leave",
                            desc: "",
                            used: listB.sick,
                            limit: 60,
                        },
                        {
                            index: 2,
                            toppic: "Medical Leave",
                            desc: "",
                            used: listB.medical,
                            limit: 120,
                        },
                        {
                            index: 3,
                            toppic: "Casual leave",
                            desc: "",
                            used: listB.casual,
                            limit: listA.casual_quota,
                        },
                    ]
                })
                .catch((e) => {
                    console.log("PROMBLEM CONNECT API ERROR !!!");
                });
        },
        calculateMonthlyStats(detail) {
            let countA = 0;
            let countAA = [];
            let countB = 0;
            let lateDays = 0;
            let lateSubA = 0;
            let lateSubB = 0;

            if (!detail || detail.length === 0) {
                return { countA, countB, lateDays, lateSubA, lateSubB };
            }

            for (const chkType of detail) {
                if (chkType.type === 'absent') {
                    countA += ![0.0, null, 0, '', '0.0', 'null'].includes(chkType.sum_min) ? 1 : 0;
                    countAA.push(Number.parseFloat(chkType.sum_min));
                } else if (chkType.type === 'full absent') {
                    countB += 1;
                    lateDays += 1;
                    lateSubB += 1;
                }
            }

            if (countAA.length !== 0) {
                const accheck = countAA.reduce((acc, curr) => acc + curr, 0);
                const lateScore = accheck > 300 ? 1 : (accheck > 180 ? 0.5 : 0);
                lateDays += lateScore;
                lateSubA += lateScore;
            }

            return { countA, countB, lateDays, lateSubA, lateSubB };
        },
        getSumLateMinutes(dataOverview) {
            if (!dataOverview || !dataOverview.detail || dataOverview.detail.length === 0) return 0;
            return dataOverview.detail
                .filter(item => item.type === 'absent')
                .reduce((sum, item) => sum + Number.parseFloat(item.sum_min || 0), 0);
        },

        async processMonthData(Calendar) {
            const c = this.monthBudget[Calendar];
            await this.getDataRequest(Calendar);

            // แปลง พ.ศ. เป็น ค.ศ. สำหรับเรียก API
            const budgetCE = Number.parseInt(this.selectedBudget) - 543;
            const setYear = Calendar < 3 ? (budgetCE - 1) : budgetCE;
            const firstDay = this.moment(`${setYear}-${c.vtext}-${Number.parseInt(this.getDayInFirst(c.value, setYear))}`)._i;
            const endDay = this.moment(`${setYear}-${c.vtext}-${Number.parseInt(this.getDayInLast(c.value, setYear))}`).format('YYYY-MM-DD');

            this.textLoading = `ระบบกำลังคำนวณข้อมูล เริ่ม ${firstDay} ถึง ${endDay}`;

            try {
                const res = await this.$http.get(`/hri/time_attendance/view_year/?timestart=${firstDay}&timeend=${endDay}`);
                if (res.status === 200) {
                    this.itemProfileSummary.push({
                        budgetQuery: this.selectedBudget,
                        startDate: firstDay,
                        endDate: endDay,
                        monthMain: c.value,
                        monthMainText: c.text,
                        yearMain: setYear,
                        dataOverview: res.data,
                    });
                    this.itemLabel.push(`${c.text} ${Number.parseInt(setYear) + 543}`);

                    const stats = this.calculateMonthlyStats(res.data.detail);

                    this.sumAllLate += stats.lateDays;
                    this.sumSubA += stats.lateSubA;
                    this.sumSubB += stats.lateSubB;

                    this.seriesA.push({ [`${setYear}-${c.vtext}`]: stats.countA });
                    this.seriesB.push({ [`${setYear}-${c.vtext}`]: stats.countB });

                    this.percent += 8.5;
                } else {
                    throw res;
                }
            } catch (error) {
                this.notiErrorApi(`/hri/time_attendance/view_year/?timestart=${firstDay}&timeend=${endDay}`, error.response ? error.response.status : 'Unknown');
            }
        },

        async getDataAbsentInBudget() {
            this.mainLoading = true;
            this.itemProfileSummary = [];
            this.itemLabel = [];
            this.seriesA = [];
            this.seriesB = [];
            this.requestA = [];
            this.requestB = [];
            this.requestC = [];
            this.requestD = [];
            this.percent = 0;
            this.sumAllLate = 0;
            this.sumSubA = 0;
            this.sumSubB = 0;
            this.seriesSum = [];

            // แปลง พ.ศ. เป็น ค.ศ. สำหรับเรียก API
            const fiscalYearCE = Number.parseInt(this.selectedBudget) - 543;
            await this.getLeaveQuota(fiscalYearCE);

            if (this.checkRoleView(['staff'])) {
                for (let Calendar = 0; Calendar < this.monthBudget.length; Calendar++) {
                    await this.processMonthData(Calendar);
                }
            }
            this.mainLoading = false;
        },
        async getDataRequest(val) {

            // set query สำหรับหาข่้อมูล
            this.requestLoading = true
            // แปลง พ.ศ. เป็น ค.ศ. สำหรับเรียก API
            const budgetCE = Number.parseInt(this.selectedBudget) - 543;
            let setYear = val < 3 ? (budgetCE - 1) : budgetCE
            let firstDay = this.moment(`${setYear}-${this.monthBudget[val].vtext}-${Number.parseInt(this.getDayInFirst(this.monthBudget[val].value, setYear))}`)._i
            let endDay = this.moment(`${setYear}-${this.monthBudget[val].vtext}-${Number.parseInt(this.getDayInLast(this.monthBudget[val].value, setYear))}`).format('YYYY-MM-DD')
            let setURLa = `/hri/leave_of_absence/?timestart=${firstDay}&timeend=${endDay}`
            let setURLb = `/hri/time-request/?timestart=${firstDay}&timeend=${endDay}`
            let setURLc = `/hri/flexible-day/me/?start=${firstDay}&end=${endDay}`
            let setURLd = `/hri/seminar-request/?timestart=${firstDay}&timeend=${endDay}`


            const fetchA = await this.$http.get(setURLa);
            const fetchB = await this.$http.get(setURLb);
            const fetchC = await this.$http.get(setURLc);
            const fetchD = await this.$http.get(setURLd);
            Promise.all([fetchA, fetchB, fetchC, fetchD])
                .then((response) => {
                    return Promise.all(response.map((r) => r.data));
                })
                .then(([listA, listB, listC, listD]) => {

                    this.requestA.push({
                        [`${setYear}-${this.monthBudget[val].value}`]: listA
                    })
                    this.requestB.push({
                        [`${setYear}-${this.monthBudget[val].value}`]: listB
                    })
                    this.requestC.push({
                        [`${setYear}-${this.monthBudget[val].value}`]: listC
                    })
                    this.requestD.push({
                        [`${setYear}-${this.monthBudget[val].value}`]: listD
                    })


                })
                .catch((e) => {
                    console.log("PROMBLEM CONNECT API ERROR !!!");
                });
        }
    }
})

</script>

<style>
.padding-graph {
    padding: 100px;
}

@media screen and (max-width: 600px) {
    .padding-graph {
        padding: 5px !important;
    }
}

/* Equal height cards */
.equal-height-row {
    display: flex;
    flex-wrap: wrap;
}

.equal-height-col {
    display: flex;
}

.equal-height-card {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.equal-height-card .ant-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* Collapse styling */
.card-collapse {
    margin-top: auto;
    background: transparent;
}

.card-collapse .ant-collapse-item {
    border-bottom: none;
    margin-bottom: 6px;
}

.card-collapse .ant-collapse-item:last-child {
    margin-bottom: 0;
}

.card-collapse .ant-collapse-header {
    padding: 10px 40px 10px 12px !important;
    font-family: 'Sarabun', sans-serif !important;
    display: flex;
    align-items: center;
}

.card-collapse .ant-collapse-content-box {
    padding: 10px 12px !important;
}

.collapse-panel-custom .ant-collapse-header {
    background-color: #f5f5f5;
    border-radius: 8px !important;
    border: 1px solid #e8e8e8;
    transition: all 0.3s ease;
}

.collapse-panel-custom .ant-collapse-header:hover {
    background-color: #ede7f6;
    border-color: #7149C6;
}

.collapse-panel-custom .ant-collapse-content {
    border-top: none;
}

.collapse-header-text {
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.collapse-header-icon {
    font-size: 14px;
    color: #7149C6;
}

/* Scrollable detail area */
.detail-scroll-area {
    max-height: 320px;
    overflow-y: auto;
    padding: 8px 10px;
    background-color: #f9f9f9;
    border-radius: 8px;
    border: 1px solid #eee;
}

.detail-scroll-area::-webkit-scrollbar {
    width: 6px;
}

.detail-scroll-area::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 3px;
}

.detail-scroll-area::-webkit-scrollbar-thumb {
    background: #c4c4c4;
    border-radius: 3px;
}

.detail-scroll-area::-webkit-scrollbar-thumb:hover {
    background: #a0a0a0;
}
</style>